import { ADDTOCART, DELETECART, MINUSQTY,PLUSQTY } from "./actionTypes";
import initialState from "./initialState";
const reducer = (state = initialState, action)=>{
    switch (action.type) {
        case ADDTOCART:
            return state.find(cart => cart.id === action.payload) ? state.map(cart => cart.id === action.payload ? {...cart, qty: cart.qty + 1} : {...cart} ): [...state,{id: action.payload, qty: 1}];            
        case PLUSQTY:                     
            return state.map(cart => cart.id === action.payload ? {...cart, qty: cart.qty + 1} : {...cart} );
        case MINUSQTY:
            return state.map(cart => cart.id === action.payload ? {...cart, qty: (cart.qty - 1) <= 1 ? 1 : (cart.qty - 1) } : {...cart} ); 
        case DELETECART:
            return state.filter(cart => cart.id !== action.payload);
        default:
            return state;
    }

}
export default reducer;